// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const magnezone: PokeData = {
  "id": 462,
  "name": "magnezone",
  "height": 12,
  "weight": 1800,
  "base_experience": 241,
  "types": [
    PokeType.ELECTRIC,
    PokeType.STEEL
  ],
  "api_moves": [
    "tackle",
    "supersonic",
    "sonic-boom",
    "thunder-shock",
    "thunderbolt",
    "thunder-wave",
    "thunder",
    "screech",
    "barrier",
    "light-screen",
    "tri-attack",
    "zap-cannon",
    "lock-on",
    "spark",
    "mirror-coat",
    "metal-sound",
    "gyro-ball",
    "magnet-rise",
    "mirror-shot",
    "flash-cannon",
    "discharge",
    "magnet-bomb",
    "electro-ball",
    "magnetic-flux",
    "electric-terrain"
  ],
  "moves": [
    "tackle",
    "supersonic",
    "thunder-shock",
    "thunderbolt",
    "thunder",
    "tri-attack",
    "zap-cannon",
    "metal-sound",
    "magnet-bomb",
    "electric-terrain",
    "volt-switch",
    "metal-claw",
    "wild-charge"
  ],
  "evolution_chain": {
    "id": 34,
    "item": null,
    "species": [
      {
        "name": "magnemite",
        "order": 88,
        "types": [
          PokeType.ELECTRIC,
          PokeType.STEEL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "magneton",
        "order": 89,
        "types": [
          PokeType.ELECTRIC,
          PokeType.STEEL
        ],
        "evolves_from_species_id": 81,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "magnezone",
        "order": 90,
        "types": [
          PokeType.ELECTRIC,
          PokeType.STEEL
        ],
        "evolves_from_species_id": 82,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": {
              "name": "mt-coronet"
            },
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          },
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": {
              "name": "chargestone-cave"
            },
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          },
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": {
              "name": "kalos-route-13"
            },
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          },
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": {
              "name": "blush-mountain"
            },
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          },
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": {
              "name": "vast-poni-canyon"
            },
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          },
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "thunder-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 125,
    "speed": 87,
    "ability_power": 188
  },
  "stat_changes": [],
  "catch_rate": 30,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
